/* 定义同步处理方法 mutations*/
/**
 * import { mapMutations } from "vuex";
 * vue组件调用方式：...mapMutations(["方法名"])
 * 一般放到vue组件的methods作用域内
 */
export default {
  // 控制登录注册弹窗框
  setShowLoginOrRegister(state, { showLogin, showRegister }) {
    state.showLogin = showLogin //更改登录框展示标识
    state.showRegister = showRegister //更改注册框展示标识
  },
  // 同步用户的信息状态
  syncUserInfo(state, info) {
    const { isMange, username } = info
    state.userInfo = info //存储登录信息
    state.isLogin = Boolean(username) //存储登录状态
    state.isAdmin = isMange //存储权限状态
  },
  //清除登录状态
  syncLogout(state) {
    state.userInfo = {}
    state.isLogin = false
    state.isAdmin = false
    window.sessionStorage.clear()
  },
}
